import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
        <div className="footer">
            <span>
                Created By <a href="/">Abinash </a>| @ 2021 All Right Reserved.
            </span>
        </div>
    );
};

export default Footer;
